// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__B0bvs","open":"MenuToggle_open__3fjF6"};